import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";
import { AllTrendingProductsFilter } from "../../../../services/ProductService/AllProductList/AllProductServices";

const FilterTrendingPopup = ({onTrendingFilteredData, onTrendingRemoveFilters, onSuccess}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [filters, setFilters] = useState([{ field_name: "", value: "", comparison_operator: "" }]);
  const [isDropdownOpen1, setIsDropdownOpen1] = useState(null);
  const [isDropdownOpen2, setIsDropdownOpen2] = useState(null);
  const [searchTerm1, setSearchTerm1] = useState("");
  const [searchTerm2, setSearchTerm2] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [filterCount, setFilterCount] = useState();

  const options = {
    "Product Id": "p_id",
    "Status": "active",
    "Product Name": "name",
    "Product Category": "category_p",
    "Product HSN Code": "p_hsn_code_no",
    "Verified": "is_verified",
    "Product Added By": "p_add_by",
    "Product Added Date": "p_add_date",
    "Product Added Time": "p_add_time",
    "Product Last Modified By": "p_last_modified_by",
    "Product Last Modified Date": "p_last_add_date",
    "Product Last Modified Time": "p_last_add_time",
    "Product Owner": "p_owner",
    "Product Recommended for": "p_recommended_for",
    "Tags": "tag",
    "Next Step": "next_step",
    "Default Unit": "default_unit",
    "Indicative Min Price": "indicative_min_price",
    "Indicative Max Price": "indicative_max_price",
    "Product Price": "p_price",
    "Product Old Price": "p_old_price",
    "Product Discount": "p_discount",
    "Production Capacity": "production_capacity",
    "Production Capacity Unit": "production_capacity_unit",
    "Present Stock Status": "present_stock_status",
    "Production Lead Time": "production_lead_time",
    "Minimum Order Quantity": "min_order_quantity",
    "Minimum Order Quantity Unit": "min_order_quantity_unit",
    "Product Life": "p_life",
    "Product LifeSpan": "p_lifespan",
    "Product Certifications": "p_certification",
    "Product Description": "p_description",
    "Product Varients": "p_varient",
  };

  const handleAddFilter = () => {
    setFilters([...filters, { field_name: "", value: "", comparison_operator: "" }]);
  };

  const handleRemoveFilter = (index) => {
    setFilters(filters.filter((_, i) => i !== index));
  };

  const handleChange = (index, field, value) => {
    const newFilters = [...filters];
    newFilters[index][field] = value;
    setFilters(newFilters);
  };

  const handleSelectfield_name = (index, key, value) => {
    const newFilters = [...filters];
    newFilters[index].field_name = value;
    setFilters(newFilters);
    setIsDropdownOpen1(null);
    setSearchTerm1("");
  };

  const handleSelectvalue = (index, key, value) => {
    const newFilters = [...filters];
    newFilters[index].value = value;
    setFilters(newFilters);
    setIsDropdownOpen2(null);
    setSearchTerm2("");
  };

  const removeFilters = () =>{
    setFilters([{ field_name: "", value: "", comparison_operator: "" }])
    setFilterCount(null)
    setIsOpen(false)
    onTrendingRemoveFilters(false)
  }

  const applyFilters = async () => {
    if (filters.every(filter => filter.field_name && filter.value && filter.comparison_operator)) {
      try {
        const responses = await Promise.all(
          filters.map(filter => AllTrendingProductsFilter('GET', { filter }))
        );
  
        const responseData = responses.map(response => response.data);

        setFilterCount(filters.length);
        onTrendingFilteredData(responseData); // Store responses in state if needed
        setIsOpen(false)
      } catch (error) {
        console.error("Error fetching filter data:", error);
      }
    } else {
      setErrorMessage("Select all fields...");
    }
  };  

  return (
    <div className="relative inline-block">
      {/* Toggle Filter Popup */}
      <p className="group-hover:text-black cursor-pointer flex items-center" >
        <p onClick={() => setIsOpen(!isOpen)}>Filter</p>
        <span className="flex items-center gap-2 ml-2">
          {filterCount && (
            <>
              <p className="px-1.5 bg-white rounded-xl">{filterCount}</p>
              <p className="px-1.5 bg-white rounded-xl cursor-pointer"  
              onClick={()=>removeFilters()}>X</p>
            </>
          )}
        </span>
      </p>

      {/* Popup Box */}
      {isOpen && (
        <div className="absolute top-10 -left-96 bg-white shadow-lg border rounded-lg w-[750px] p-4 z-50">
          {filters.map((filter, index) => (
            <div key={index} className="flex items-center space-x-2 mb-2 relative">
              {/* Searchable Field Dropdown 1 */}
              <div className="w-1/3 relative">
                <input
                  type="text"
                  placeholder="Select"
                  className="border border-gray-400 bg-gray-200 text-gray-500 rounded-lg px-3 outline-none w-fit cursor-pointer"
                  value={Object.keys(options).find((key) => options[key] === filter.field_name) || ""}
                  readOnly
                  onClick={() => setIsDropdownOpen1(index === isDropdownOpen1 ? null : index)}
                />
                {isDropdownOpen1 === index && (
                  <div className="absolute top-12 left-0 bg-white border rounded w-fit shadow-lg z-10 p-3">
                    <input
                      type="text"
                      placeholder="Search..."
                      className="border border-gray-400 rounded-lg px-3 outline-none w-full"
                      value={searchTerm1}
                      onChange={(e) => setSearchTerm1(e.target.value)}
                    />
                    <div className="h-60 w-fit overflow-y-scroll">
                      {Object.keys(options)
                        .filter((key) => key.toLowerCase().includes(searchTerm1.toLowerCase()))
                        .map((key) => (
                          <p key={key} className="px-3 py-2 hover:bg-gray-100 cursor-pointer" onClick={() => handleSelectfield_name(index, key, options[key])}>
                            {key}
                          </p>
                        ))}
                    </div>
                  </div>
                )}
              </div>

              {/* Operator Dropdown */}
              <select className="border px-3 rounded-lg w-1/3 cursor-pointer outline-none" value={filter.comparison_operator} onChange={(e) => handleChange(index, "comparison_operator", e.target.value)}>
                <option value="select">Select</option>
                <option value="equals">Equals</option>
                <option value="not_equals">Not Equals</option>
                <option value="like">Like</option>
                <option value="not_like">Not Like</option>
                <option value="in">In</option>
                <option value="not_in">Not In</option>
                <option value="is">Is</option>
              </select>

              {/* Searchable Field Dropdown 2 */}
              <div className="w-1/3 relative">
                <input
                  type="text"
                  placeholder="Select"
                  className="border border-gray-400 bg-gray-200 text-gray-500 rounded-lg px-3 outline-none w-fit cursor-pointer"
                  value={Object.keys(options).find((key) => options[key] === filter.value) || ""}
                  readOnly
                  onClick={() => setIsDropdownOpen2(index === isDropdownOpen2 ? null : index)}
                />
                {isDropdownOpen2 === index && (
                  <div className="absolute top-12 left-0 bg-white border rounded w-fit shadow-lg z-10 p-3">
                    <input
                      type="text"
                      placeholder="Search..."
                      className="border border-gray-400 rounded-lg px-3 outline-none w-full"
                      value={searchTerm2}
                      onChange={(e) => setSearchTerm2(e.target.value)}
                    />
                    <div className="h-60 w-fit overflow-y-scroll">
                      {Object.keys(options)
                        .filter((key) => key.toLowerCase().includes(searchTerm2.toLowerCase()))
                        .map((key) => (
                          <p key={key} className="px-3 py-2 hover:bg-gray-100 cursor-pointer" onClick={() => handleSelectvalue(index, key, options[key])}>
                            {key}
                          </p>
                        ))}
                    </div>
                  </div>
                )}
              </div>

              {/* Remove Filter Button */}
              {filters.length > 1 && <button className="text-red-500" onClick={() => handleRemoveFilter(index)}><FaTimes /></button>}
            </div>
          ))}

          {/* Add Filter Button */}
          <button className="text-blue-500 text-sm mb-2" onClick={handleAddFilter}>+ Add Filter</button>

          {errorMessage && (<p className="mx-5 text-red-600">{errorMessage}</p>)}

          {/* Buttons */}
          <div className="flex justify-end space-x-2">
            <button className="px-3 py-1 border rounded text-gray-700 text-sm" onClick={() =>{setFilters([{ field_name: "", value: "", comparison_operator: "" }]);setFilterCount(null)}}>
              Clear
            </button>
            <button className="px-3 py-1 bg-blue-500 text-white rounded text-sm"
              onClick={() => applyFilters()}>Apply Filter</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default FilterTrendingPopup;